import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import {
  LOAN_DIFFERE_CONTROL,
  LOAN_DIFFERE_NONE,
  LOAN_DURATION_DIFFERE_CONTROL,
  LOAN_PALIERS_CONTROL,
  LOAN_PALIERS_ENABLED_CONTROL,
  LOAN_PALIERS_MIN,
  LOAN_PALIER_DIFFERE_CONTROL,
  LOAN_PALIER_DURATION_CONTROL,
  LOAN_PALIER_MONTHLY_PAYMENT_CONTROL,
  LoanPalier,
  LoanPalierFormValue,
} from './loan-palier.model';
import { LoanPalierValidators } from './loan-palier.validators';
import { paliersApiToForm } from './loan-palier.utils';

export function createLoanPalierGroup(
  formBuilder: UntypedFormBuilder,
  value?: LoanPalierFormValue,
): UntypedFormGroup {
  return formBuilder.group({
    [LOAN_PALIER_DURATION_CONTROL]: [
      value?.durationInMonth ?? '',
      LoanPalierValidators.duration(),
    ],
    [LOAN_PALIER_MONTHLY_PAYMENT_CONTROL]: [
      value?.monthlyPayment ?? '',
      LoanPalierValidators.monthlyPayment(),
    ],
    [LOAN_PALIER_DIFFERE_CONTROL]: [
      value?.differe ?? LOAN_DIFFERE_NONE,
      LoanPalierValidators.differe(),
    ],
  });
}

export function createLoanPaliersArray(
  formBuilder: UntypedFormBuilder,
  paliers?: LoanPalier[] | null,
): UntypedFormArray {
  return formBuilder.array(
    paliersApiToForm(paliers).map(palier =>
      createLoanPalierGroup(formBuilder, palier),
    ),
    LoanPalierValidators.array(),
  );
}

export function getLoanPaliersArray(
  loanGroup: UntypedFormGroup,
): UntypedFormArray | null {
  return (loanGroup?.get(LOAN_PALIERS_CONTROL) as UntypedFormArray) ?? null;
}

export function refreshLoanPaliersValidity(loanGroup: UntypedFormGroup): void {
  const array = getLoanPaliersArray(loanGroup);

  if (!array) {
    return;
  }

  array.controls.forEach(rowGroup => {
    Object.values((rowGroup as UntypedFormGroup).controls).forEach(control =>
      control.updateValueAndValidity({ emitEvent: false }),
    );
  });

  array.updateValueAndValidity({ emitEvent: false });
}

export function refreshLoanDiffereValidity(loanGroup: UntypedFormGroup): void {
  [LOAN_DIFFERE_CONTROL, LOAN_DURATION_DIFFERE_CONTROL].forEach(name =>
    loanGroup?.get(name)?.updateValueAndValidity({ emitEvent: false }),
  );
}

export function withLoanFormValidity(
  loanGroup: UntypedFormGroup,
): UntypedFormGroup {
  refreshLoanPaliersValidity(loanGroup);
  refreshLoanDiffereValidity(loanGroup);

  return loanGroup;
}

export function fillLoanPaliersToMinimum(
  formBuilder: UntypedFormBuilder,
  loanGroup: UntypedFormGroup,
): void {
  const array = getLoanPaliersArray(loanGroup);

  if (!array) {
    return;
  }

  while (array.length < LOAN_PALIERS_MIN) {
    array.push(createLoanPalierGroup(formBuilder));
  }

  refreshLoanPaliersValidity(loanGroup);
}

export function neutralizeLoanPaliers(loanGroup: UntypedFormGroup): void {
  const enabledControl = loanGroup?.get(LOAN_PALIERS_ENABLED_CONTROL);

  if (enabledControl && enabledControl.value !== false) {
    enabledControl.setValue(false);
  }

  refreshLoanPaliersValidity(loanGroup);
}
